import request from './index';
import type { IPlatformUsersResponse } from 'types/platformUser';

export const getPlatformUsers = () =>
  request<IPlatformUsersResponse>({
    options: {
      url: '/platform/admin/users',
      method: 'get'
    }
  });
